define(function() {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const theModel = require('civicsModels/portal/scenario_model');
	const urlBuilder = require('civicsUtils/buildUrlParameters');
	return IpsModelCollection.extend({
		model: theModel,
		urlRoot: 'delegate/civics-api/api/portal/scenarios',
		url:function(){
			var ret = this.urlRoot;
			if(this.projectId != null){
				var parms = urlBuilder.buildUrlParameters({
					filter:{
						property:'Application',
						value:this.projectId,
						operator:'Equal'
					}
				});
				ret+=parms;
			}
			else if( this.urlParameters){
				ret += urlBuilder.buildUrlParameters(this.urlParameters)
			}
			return ret;
		}
	});
});
